// @ts-ignore
/* eslint-disable */
import {
  getFileEndpointApiAdminFilesFileIdGet,
  getFileByUrlEndpointApiAdminFilesByUrlGet,
  uploadFileEndpointApiAdminFilesUploadPost,
  generateUploadUrlEndpointApiAdminFilesUploadUrlPost,
  batchGetFilesByUrlEndpointApiAdminFilesBatchByUrlPost,
} from './generated/file';

/**
 * 根据ID获取文件信息
 * GET /api/admin/files/{file_id}
 */
export async function getFile(
  fileId: string,
  options?: { [key: string]: any },
) {
  return getFileEndpointApiAdminFilesFileIdGet(
    {
      file_id: fileId,
    },
    options,
  );
}

/**
 * 根据URL获取文件信息
 * GET /api/admin/files/by-url
 */
export async function getFileByUrl(
  fileUrl: string,
  options?: { [key: string]: any },
) {
  return getFileByUrlEndpointApiAdminFilesByUrlGet(
    {
      file_url: fileUrl,
    },
    options,
  );
}

/**
 * 上传文件（服务端中转）
 * POST /api/admin/files/upload
 *
 * 通过服务端中转上传文件（降级方案）
 * 适用于：
 * - 老版本浏览器不支持直传
 * - 需要在上传前进行文件校验
 * - 需要统一处理上传逻辑
 *
 * 注意：此方式会占用服务端带宽，建议优先使用直传方式。
 */
export async function uploadFile(
  file: File,
  params: {
    business_type: string;
    custom_prefix?: string | null;
  },
  options?: { [key: string]: any },
) {
  return uploadFileEndpointApiAdminFilesUploadPost(
    {
      business_type: params.business_type,
      custom_prefix: params.custom_prefix,
    },
    {},
    file,
    options,
  );
}

/**
 * 生成文件上传URL（直传）
 * POST /api/admin/files/upload-url
 *
 * 生成文件直传签名URL（客户端直接上传到OSS）
 * 建议优先使用此方式，避免占用服务端带宽。
 *
 * 使用流程：
 * 1. 调用此接口获取 upload_url 和 form_data
 * 2. 构建multipart/form-data请求：
 *    - 将 form_data 中的所有字段作为表单字段（必须原样透传，不能修改任何值）
 *    - 添加一个名为 file 的文件字段，值为要上传的文件
 * 3. POST到 upload_url，上传成功后可直接使用返回的 file_url 访问文件
 */
export async function generateUploadUrl(
  body: API.GenerateUploadUrlRequest,
  options?: { [key: string]: any },
) {
  return generateUploadUrlEndpointApiAdminFilesUploadUrlPost(body, options);
}

/**
 * 批量根据URL获取文件信息
 * POST /api/admin/files/batch-by-url
 *
 * 批量查询多个文件的信息，支持最多100个URL
 * 如果某个URL未找到对应的文件记录，则返回null
 */
export async function batchGetFilesByUrl(
  urls: string[],
  options?: { [key: string]: any },
) {
  return batchGetFilesByUrlEndpointApiAdminFilesBatchByUrlPost(
    {
      urls,
    },
    options,
  );
}
